import type { NextPage } from 'next';
import underConstructionImage from '../../public/images/under-construction.png';
import { ContactComponent, getStaticPropsNicho } from 'ui';

const ContactPage: NextPage = () => {
	return <ContactComponent image={underConstructionImage} />;
};

export const getStaticProps = getStaticPropsNicho();
export default ContactPage;
